import SettingsHeader from "./settings-header.container";

export default SettingsHeader;
